"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROFILING_STATUSES = void 0;
exports.PROFILING_STATUSES = Object.freeze({
    PHOTOS_REQUESTED: 'photos_requested',
    SERVICE_HISTORY: 'service_history',
    POP_REQUESTED: 'pop_requested',
    FINANCE: 'finance',
    PREP_QUERY: 'prep_query',
    CONFIRMING_RESERVE_WITH_SELLER: 'confirming_reserve_with_seller',
    OTHER: 'other',
});
//# sourceMappingURL=profilingStatuses.js.map